// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"d1527dad","186":"33e7f70d","472":"7561a8af","622":"d7898853","863":"2241f674","908":"49a5b075"}[chunkId] + ".chunk.js";
};